module.exports = __webpack_public_path__ + "static/img/guidance111.375258a8.png";